























import Vue from "vue";

export default Vue.extend({
  name: "MainTextSection",
  props: ["title", "logo", "subTitle", "content", "showLearnMore"]
});
